import { PureComponent, createRef } from 'react'
import { Button } from 'antd'
import { InstagramOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import Music from '../music'
import styles from './index.module.scss'
import BlueLogo from './logo-white.png'
import WhiteLogo from './logo-white.png'
import  facebookLogo from './facebook.png'

import { getContent } from './content.js'

export default class Header extends PureComponent {
  textRef = createRef()
  audioRef = createRef()
  musicRef = createRef()

  handleClick = () => {
    window.open('https://cemoy.com/shop/')
  }

  calcLineCount = () => {
    const { style } = this.textRef.current

    style.visibility = 'hidden'
    setTimeout(() => {
      const lineCount = this.textRef.current.getClientRects().length
      if (lineCount > 1) {
        style.visibility = 'hidden'
      } else {
        style.visibility = 'visible'
      }
    }, 30)
  }

  hackAudioAutoplay = (e) => {
    const handler = e => {
      this.audioRef.current.play().catch(err => {
        console.log('error', err)
      }).then(() => {
        document.removeEventListener('click', handler)
        this.musicRef.current.musicTrans(true)
      })
    }
    document.addEventListener('click', handler)
  }

  autoPlayAudio = () => {
    // 在用户没有操作 dom 时，chrome 会拦截自动播放音乐，设置定时器重复检测
    // ios safari 必须在操作事件回调中调用 audio.play() 才会播放音乐
    if (this.audioRef.current.paused) {
      this.audioRef.current.play().catch(e => {
        console.log('audio auto play err', e)
        this.hackAudioAutoplay()
      })
    }
  }

  componentDidMount () {
    this.autoPlayAudio()
    this.calcLineCount()
    window.addEventListener('resize', this.calcLineCount)
  }

  musicTrans(){

  }

  openUrl(url){
    window.open(url)
  }

  render () {
    const { color, language } = this.props

    return (
      <div className={classNames(styles.header, {
        [styles.blue]: color === 'blue'
      })}>
        <div className={styles.left}>
          <p>{ getContent(language, 'header_share_btn') }</p>&nbsp;
          {/* <a href="javascript:window.open('https://www.facebook.com/sharer/sharer.php?u=http://54.252.255.15/doc/cemoy-sv/index.html')">
            <i className='iconfont icon-Facebook' style={{ fontSize: '12px', width: '15px', transform: 'scale(.8)' }} alt=''></i>
          </a>
          <a href="javascript:window.open('https://www.instagram.com/cemoyofficial/')">
            <InstagramOutlined style={{ fontSize: '6px' }}></InstagramOutlined>&nbsp;
          </a> */}
         { getContent(language, 'header_share_icon1') }
         { getContent(language, 'header_share_icon2') }
          <Music ref={this.musicRef} color={color} clickHandle={this.props.toggleAudioTransPlay}></Music>&nbsp;&nbsp;
          <p className={styles.soundname}><span ref={this.textRef} className={styles.headerText}>{ getContent(language, 'header_music_name') }</span></p>
          <audio ref={this.audioRef} src={`${process.env.PUBLIC_URL}/resource/Lofi_Is.mp3`} loop autoPlay></audio>
        </div>
        <img src={color === 'blue' ? BlueLogo : WhiteLogo} className={styles.logo} alt="" />
        <div>
        <a href={ getContent(language, 'header_shop_url') } target="_blank" className={styles.headerShop} rel="noreferrer">{ getContent(language, 'header_shop_btn') }</a>
        {/*<Button type='primary' className={styles.btnshop} onClick={this.handleClick}>SHOP</Button>*/}
        </div>
      </div>
    )
  }
}
